import { Button, Card, Conditional, Textarea } from '@payaca/ambrosia';
import { FC, PropsWithChildren, useMemo } from 'react';

import { useSelector } from '@/api/state';

type Props = {
  onChange: (change: any) => void;
  emailCopy: {
    preButton: string;
    postButton: string;
  };
  buttonText: string;
  hasButton?: boolean;
};

const EmailPreview: FC<PropsWithChildren<Props>> = ({
  onChange,
  emailCopy,
  buttonText,
  hasButton = true,
  children,
}) => {
  const myProfile = useSelector((state: any) => state.users.myProfile);

  const logoUrl = useMemo(() => myProfile?.accounts?.[0]?.logoUrl, [myProfile]);

  return (
    <Card>
      <Card.Body>
        <div className="text-center">
          <img
            className="mb-3 h-auto max-w-52"
            src={logoUrl}
            alt="Company logo"
          />
        </div>

        <Textarea
          className="resize-y text-center"
          value={emailCopy.preButton || ''}
          onChange={(value) => {
            onChange({ preButton: value });
          }}
        />

        {children}

        <Conditional condition={hasButton}>
          <div className="my-4 text-center">
            <Button disabled>{buttonText}</Button>
          </div>
        </Conditional>

        <Textarea
          className="resize-y text-center"
          value={emailCopy.postButton}
          onChange={(value) => {
            onChange({ postButton: value });
          }}
        />
      </Card.Body>
    </Card>
  );
};

export default EmailPreview;
